<template>
  <v-data-table
    show-select
    v-model="localValue"
    :headers="headers"
    :items="produtos.content"
    class="elevation-1 mt-2"
    :loading="loading"
    :server-items-length="produtos.total"
    @update:options="updateOptions"
    @item-selected="onSelectItem"
    :footer-props="footerOptions"
    no-data-text="Nenhum produto encontrado"
    loading-text="Carregando produtos..."
    :options="optionsList"
  >
    <template v-slot:footer.page-text>
      <span></span>
    </template>
    <template v-slot:item.produto.descricao="{ item }">
      <px-span-tooltip top
                      :text="descricaoLabel(descricaoProduto(item))"
                      :tooltip="descricaoProduto(item)"/>
    </template>
    <template v-slot:item.quantidade="{ item }">
      {{
        item.quantidade
          | number(getCurrencyFormat(item))
      }}
      {{ item.unidadeMedida.descricao }}
    </template>
    <template v-slot:item.createdIn="{ item }">
      {{item.createdIn | date}}
    </template>
    <template v-slot:item.urgencia="{ item }">
      <px-requisicao-urgencia :urgencia="item.requisicao.urgencia"/>
    </template>
    <template v-slot:item.requisicao.identificador="{ item }">
      <px-span-tooltip top
                    :text="identificadorLabel(item.requisicao.identificador)"
                    :tooltip="item.requisicao.identificador" />
      <v-btn icon small link target="_blank" :to="requisicaoLink(item)">
        <v-icon small>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import Vue from 'vue';
import { CasaDecimalUtils } from 'px-components';

export default {
  props: {
    value: Array,
    produtos: Object,
    loading: Boolean,
    optionsList: Object,
    onChangeOptions: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'produto.codigo',
          sortable: false,
        },
        {
          text: 'Produto',
          value: 'produto.descricao',
          sortable: false,
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Solicitado em',
          value: 'createdIn',
          sortable: false,
        },
        {
          text: 'Urgência',
          value: 'urgencia',
          sortable: false,
        },
        {
          text: 'Solicitação',
          value: 'requisicao.identificador',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    getCurrencyFormat() {
      return (item) => {
        const casasDecimais = item.produto ? item.produto.casasDecimais : null;
        return CasaDecimalUtils.getCurrencyFormat(casasDecimais);
      };
    },
    descricaoProduto() {
      return item => (item.produto ? item.produto.descricao : item.especificacaoProduto);
    },
    identificadorLabel() {
      return identificador => Vue.filter('truncate')(identificador, 10);
    },
    descricaoLabel() {
      return descricao => Vue.filter('truncate')(descricao, 30);
    },
    requisicaoLink() {
      return item => `/requisicao/${item.requisicao.id}`;
    },
  },
  methods: {
    onSelectItem() {
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
  },
};
</script>
